export default {
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
    search: '搜索电影...',
    latest: '最新电影',
    hot: '热门推荐',
    all: '全部电影',
  },
  footer: {
    brand: '6080影视',
    slogan: '免费高清电影在线观看平台，每日更新最新大片，无需VIP享受流畅播放体验。',
    quickLinks: '快速链接',
    categories: '电影分类',
    contactUs: '联系我们',
    email: 'service@6080ys.com',
    copyright: '© 2024 6080影视 - 6080新视觉影视 版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
  },
  common: {
    viewMore: '查看更多',
    backToHome: '返回首页',
    noData: '暂无数据',
    loading: '加载中...',
    scrollTop: '回到顶部',
    play: '播放',
    quality: '画质',
    rating: '评分',
    year: '年份',
    director: '导演',
    actors: '主演',
    duration: '片长',
    description: '简介',
    relatedMovies: '相关推荐',
  },
};